import React, { useState } from 'react';
import './blog-post.css';
import './blog-slides.css';

import ghctapia1 from './pictures/ghc1.png';
import ghctapia2 from './pictures/ghc2.png';
import ghctapia3 from './pictures/ghc3.png';
import ghctapia4 from './pictures/ghc4.png';
import ghctapia5 from './pictures/ghc5.png';

const GHCTapia = () => {
  return (
    <div>
      <div className='blog__container'>
        <div class="row">
            <div class="column">
                <header></header>

                <section>
                    <h2>Grace Hopper & Tapia Reflection Dinner</h2>
                    <p class="site-post-meta">December 3rd, 2024</p>
                    <hr></hr>
                </section>
                <section>
                    <p>
                    Hi WiC members! 
                    <br></br>
                    <br></br>
                    On December 3rd, WiC partnered with Allen School staff to host and lead the Grace Hopper and Tapia Reflection Dinner! The Allen School’s Grace Hopper and Tapia conference attendees engaged in a Mission and Impact activity, a very insightful discussion about student experience and creating supportive spaces in tech, and enjoyed Thai food for dinner!
                    </p>
                    <img src={ghctapia1} alt="pic1 "/>
                    <img src={ghctapia2} alt="pic2"/>
                    <img src={ghctapia3} alt="pic4"/>
                    <img src={ghctapia4} alt="pic5"/>
                    <img src={ghctapia5} alt="pic6"/>
                </section>
            </div>
        </div>      
      </div>
    </div>
  );
};

export default GHCTapia;
